import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, type Language } from '@il-colpo/shared/settings';
import { useSettingsStore } from '../state/settingsStore.ts';
import { Button, Logo, Panel } from '../ui/index.ts';
import styles from './FirstRun.module.css';

/**
 * First launch: language. The spec also lists a playable mini-tutorial, avatar and nickname,
 * and an account invitation; those arrive with the milestones that own them (see STATUS).
 */
export function FirstRun() {
  const { t } = useTranslation('firstRun');
  const { t: tc } = useTranslation('common');
  const navigate = useNavigate();
  const language = useSettingsStore((s) => s.settings.language);
  const update = useSettingsStore((s) => s.update);

  const choose = (lang: Language) => {
    update((s) => {
      s.language = lang;
    });
  };

  const done = () => {
    update((s) => {
      s.firstRunDone = true;
    });
    void navigate('/', { replace: true });
  };

  return (
    <main id="main" tabIndex={-1} className={styles['page']}>
      <Logo label={tc('appName')} />
      <Panel as="div" className={styles['card']}>
        <h1 className={styles['title']}>{t('title')}</h1>
        <p className={styles['subtitle']}>{t('subtitle')}</p>
        <div className={styles['choices']} role="radiogroup" aria-label={t('title')}>
          {LANGUAGES.map((lang) => (
            <Button
              key={lang}
              variant="secondary"
              size="lg"
              selected={language === lang}
              role="radio"
              aria-checked={language === lang}
              onClick={() => {
                choose(lang);
              }}
              lang={lang}
            >
              {tc(`languages.${lang}`)}
            </Button>
          ))}
        </div>
        <Button size="lg" block onClick={done}>
          {t('continue')}
        </Button>
      </Panel>
    </main>
  );
}
